AsignacionFormCtrl.$inject = ['$log', '$scope', '$http', '$timeout'];
export default function AsignacionFormCtrl($log, $scope, $http, $timeout) {

    $scope.$on('datosFormAsignacion', function (event, data) {
        asigCtrl.datos = data.data;
        asigCtrl.model = data.model;
        if (asigCtrl.model.estado_tecnico_id == estadoTecnicoCerradaId) asigCtrl.crear_finalizada = true;
        if (asigCtrl.mostrarAsignacionAHijos && !asigCtrl.datos.esTipoPadre) asigCtrl.mostrarAsignacionAHijos = false;
        asigCtrl.cambiaEstadoTecnico();
    });

    var asigCtrl = this;
    asigCtrl.hayTecnicoYReparador = false;
    asigCtrl.nohayTecnicoNiReparador = false;
    asigCtrl.hayTecnicoYNoReparadorONoHayTecnicoYReparador = false;

    asigCtrl.estadoTecnicoSelecionado = null;
    asigCtrl.hayEstadoReparacion = false;
    asigCtrl.estadoReparacionSelecionado = false;
    asigCtrl.crear_finalizada = false;

    asigCtrl.mostrarAsignacionAHijos = issetAndNotEmpty($scope.mostrarAsignacionAHijos) ? $scope.mostrarAsignacionAHijos : false;
    asigCtrl.asignacion_a_hijos = false;

    var estadoTecnicoPendienteId = Sigo.estado.TECNICO.PENDIENTE;
    var estadoTecnicoAsignadaId = Sigo.estado.TECNICO.ASIGNADA;
    var estadoTecnicoCerradaId = Sigo.estado.TECNICO.CERRADA;

    var estadoReparacionPendienteId = Sigo.estado.TAREA.PENDIENTE;
    var estadoReparacionPendienteEntId = Sigo.estado.TAREA.PENDIENTE_ENTIDAD_REPARADORA;
    var estadoReparacionFinalizadaId = Sigo.estado.TAREA.FINALIZADA;

    var estado;
    asigCtrl.cambiaEstadoTecnico = function (tipo) {
        // switch (tipo) {
        //     case 'ent_est':
        //         asigCtrl.model.tecnico_id = null;
        //         break;
        //     case 'tec':
        //         asigCtrl.model.entidad_estudio_id = null;
        //         break;
        //     case 'ent_rep':
        //         asigCtrl.model.reparador_id = null;
        //         break;
        //     case 'rep':
        //         asigCtrl.model.entidad_reparadora_id = null;
        //
        // }

        var hayTecnicoOEntTec = asigCtrl.model.tecnico_id || asigCtrl.model.entidad_estudio_id;
        var hayReparadorOEntRep = asigCtrl.model.reparador_id || asigCtrl.model.entidad_reparadora_id;

        asigCtrl.hayTecnicoYReparador = hayTecnicoOEntTec && hayReparadorOEntRep;
        asigCtrl.nohayTecnicoNiReparador = !hayTecnicoOEntTec && !hayReparadorOEntRep;
        asigCtrl.hayTecnicoYNoReparadorONoHayTecnicoYReparador = (hayTecnicoOEntTec && !hayReparadorOEntRep) || (!hayTecnicoOEntTec && hayReparadorOEntRep);

        if (asigCtrl.hayTecnicoYNoReparadorONoHayTecnicoYReparador || asigCtrl.crear_finalizada) {

            var estadoABuscar = asigCtrl.crear_finalizada ? estadoTecnicoCerradaId
                : (hayTecnicoOEntTec ? estadoTecnicoPendienteId : (hayReparadorOEntRep ? estadoTecnicoAsignadaId : null));

            if (estadoABuscar != null) {
                estado = buscaEstadoPorId(asigCtrl.datos.estadosTodos, estadoABuscar);
                asigCtrl.estadoTecnicoSelecionado = estado;
                asigCtrl.model.estado_tecnico_id = estado.id;
            }

        } else {
            if (asigCtrl.model.estado_tecnico_id != estadoTecnicoPendienteId && asigCtrl.model.estado_tecnico_id != estadoTecnicoAsignadaId)
                asigCtrl.model.estado_tecnico_id = estadoTecnicoPendienteId;
        }
        cambiaEstadoReparacion();
    };

    var cambiaEstadoReparacion = function () {
        var estTecSelecId = asigCtrl.model.estado_tecnico_id;

        var estadoABuscar = estTecSelecId == estadoTecnicoAsignadaId
            ? (asigCtrl.model.reparador_id ? estadoReparacionPendienteId : estadoReparacionPendienteEntId)
            : (estTecSelecId == estadoTecnicoCerradaId ? estadoReparacionFinalizadaId : null);

        if (estadoABuscar != null) {
            estado = buscaEstadoPorId(asigCtrl.datos.estadosTodos, estadoABuscar);
            asigCtrl.hayEstadoReparacion = true;
            asigCtrl.estadoReparacionSelecionado = estado;
        } else {
            asigCtrl.hayEstadoReparacion = false;
        }
    };

    var buscaEstadoPorId = function (estados, estadoBuscadoId) {
        for (var i = 0; i < estados.length; i++) {
            if (estados[i].id == estadoBuscadoId) {
                return estados[i];
            }
        }
        return null;
    };

}